import React from 'react';
import cx from 'classnames';
import _ from 'lodash';

import InfiniteScroll from 'components/InfiniteScroll';
import { ContentCard, ContentCardPlaceholder } from '../sectionManager/components/contentCard';
import { resolveManualLayoutMappingId } from './layoutMappingIds';
import { usePersonalizationFilteredContents } from './PersonalizationShowSelectedContext';

import personalizeStyles from './personalization.module.scss';
import styles from '../sectionManager/manualSection/manualSection.module.scss';

export const PersonalizationManualPersonalizeGrid = ({
  containerRef,
  contents,
  loading,
  hasMoreItems,
  loadMore,
  activeAssetIds,
  onToggleAsset,
}) => {
  const displayContents = usePersonalizationFilteredContents(
    contents,
    activeAssetIds,
    resolveManualLayoutMappingId,
  );

  return (
    <div className={cx(personalizeStyles.personalizeGridHost, personalizeStyles.personalizeGridSection)}>
      <InfiniteScroll
        className={personalizeStyles.personalizeGrid}
        containerRef={containerRef}
        loading={loading}
        hasMore={hasMoreItems}
        loadMore={loadMore}
      >
        {displayContents.map((data) => {
          const mappingId = resolveManualLayoutMappingId(data);
          const selected = mappingId ? activeAssetIds.includes(mappingId) : false;
          return (
            <div
              key={mappingId || _.get(data, 'content.id')}
              className={cx(styles.contentWrapper, personalizeStyles.personalizeGridCard)}
            >
              <ContentCard
                selected={selected}
                onSelect={() => {
                  if (!mappingId) return;
                  onToggleAsset(mappingId, !selected);
                }}
                assetData={data}
                contentType="MANUAL"
                className={cx({ [personalizeStyles.personalizeCardMuted]: !selected })}
              />
            </div>
          );
        })}
        {loading &&
          _.times(_.size(displayContents) === 0 ? 4 : 7).map((index) => (
            <ContentCardPlaceholder key={index} />
          ))}
      </InfiniteScroll>
    </div>
  );
};
